exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table > thead > tr > th[data-v-7d1eaf6a] {\n  vertical-align: top;\n}", ""]);

// exports
